import react from "react";

//components
import LoadingSpinner from "@/components/elements/search/LoadingSpinner/LoadingSpinner";

//styling
import "../../../../css/global/lists/tooltipDropdownList.scss";



interface dropdownListItem {
    title: string,
    subtitle: string,
    displayIcon: boolean,
    icon: any,
}



const TooltipDropdownList = ({show, isLoading, items, extraDetailText, tooltipTitle, style}:{show: boolean, isLoading: boolean, items: dropdownListItem[], extraDetailText?: string, tooltipTitle?: string,  style?: React.CSSProperties}) => {   
    
    if (!show || !items){
        return <></>
    }

    if (isLoading) {
        return <div className={`tooltip-dropdown-list list-loading`}><LoadingSpinner size={8}/></div>
    } 

    return (
        <ul className={`tooltip-dropdown-list`} style={style}> 
            {tooltipTitle && (
                <li className={`tooltip-item more-items`}>
                    <span className="remaining-details">{tooltipTitle}</span>
                </li>
            )}
            
            {items.map((item, index) => (
                <li key={index} className={`tooltip-item`} >
                    {item.displayIcon && <div className="icon-wrapper">{item.icon}</div>}

                   <div className="details">
                        <span className="title">{item.title}</span>
                        <span className="subtitle">{item.subtitle}</span>
                   </div>
                </li>
            ))}

            {extraDetailText && (
                <li className={`tooltip-item more-items`}>
                    <span className="remaining-details">{extraDetailText}</span>
                </li>
            )}
        </ul>
    );
}

export default TooltipDropdownList